module.exports = __webpack_public_path__ + "static/img/The Empress.0b5622c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/The Empress.jpg
// module id = 1311
// module chunks = 0